import axios from "../utils/axios";
import {ICompanyAPIKey} from "../models/CompanyAPIKey";

export function fetchCompaniesAPIKeys(token: string ) {
  return new Promise((resolve, reject) => {
    axios
      .get<ICompanyAPIKey[]>(`${process.env.REACT_APP_API_DOMAIN}/company_api_keys/`, {
        headers: { Authorization: "Token " + token },
      })
      .then((response: any) => {
        if (response.status === 200) {
          const contract: ICompanyAPIKey[] = response.data.results
          resolve(contract);
        }
        reject(response.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
}


export function fetchCompaniesAPIKeysByCompany(company: string, token: string ) {
  return new Promise((resolve, reject) => {
    axios
      .get<ICompanyAPIKey[]>(`${process.env.REACT_APP_API_DOMAIN}/company_api_keys/?company=${company}`, {
        headers: { Authorization: "Token " + token },
      })
      .then((response: any) => {
        if (response.status === 200) {
          const contract: ICompanyAPIKey[] = response.data.results
          resolve(contract);
        }
        reject(response.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function createCompanyAPIKey(data: object, token: string) {
  return new Promise((resolve, reject) => {
    axios
      .post(`${process.env.REACT_APP_API_DOMAIN}/company_api_keys/`, data, {
        headers: { Authorization: "Token " + token },
      })
      .then((response) => {
        if (response.status === 201) {
          resolve(response);
        }
        reject(response.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
}


export function updateCompanyAPIKey(prefix: string, data: object, token: string) {
  return new Promise((resolve, reject) => {
    axios
      .patch(`${process.env.REACT_APP_API_DOMAIN}/company_api_keys/${prefix}/`, data, {
        headers: { Authorization: "Token " + token },
      })
      .then((response) => {
        if (response.status === 200) {
          resolve(response);
        }
        reject(response.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
}